export default __webpack_public_path__ + "static/renner_500_medium-webfont-011f7be6e253ca97d9639defd7daba97.woff";